import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const calendarCustomButtonVariants = tv({
  base: "w-full",
  variants: {
    target: {
      default: "text--(--gray-text-2-alpha)",
      target: "bg-(--primary-1) hover:bg-(--primary-1) text-(--pure-white)",
      outsideView: "text-(--gray-primary-2-alpha)"
    }
  },
  defaultVariants: {
    target: "default"
  }
});
export {
  calendarCustomButtonVariants
};
//# sourceMappingURL=index.js.map
